import jsGlobalConfig from '../../globals/jsGlobalConfig';
import httpRequest from '../../utilities/js/httpRequest/httpRequest';
import encodeFormData from '../../utilities/js/encodeFormData/encodeFormData';

class ReviewService {
  protected urls: {
    saveHelpful: string,
  };

  constructor() {
    this.urls = window.__productConfig.apiUrls.review;
  }

  saveHelpful(productId: string, reviewId: string, helpful: string): Promise<any> {
    return httpRequest.post(this.urls.saveHelpful,
      this.getDataObj({
        productId: '' + productId,
        helpful: '' + helpful,
        reviewId: '' + reviewId
      }));
  }

  protected getDataObj(params = {}) {
    return encodeFormData({...params, ...jsGlobalConfig().getCsrfTokenData()});
  }
}

const reviewService = new ReviewService();
export default reviewService;
